// prettier-ignore
export default "2025.0623.1036"